import { Type } from 'class-transformer';
import { PropertyDetails } from 'types/models/inventory/PropertyDetails';
import { Nullable } from '@cast/leadcast-types';
import { Material } from './inventory/Material';

export interface OnPremisePlumbing {
  id: string;
  propertyId: PropertyDetails['id'];
  material: Material;
  isLeadSolder: Nullable<boolean>;
  hasPointOfEntryFilter: Nullable<boolean>;
  hasPointOfUseFilter: Nullable<boolean>;
  hasWholeHouseWaterSoftener: Nullable<boolean>;
  installYear: Nullable<number>;
  source: Nullable<string>;
}

export class OnPremisePlumbing {
  @Type(() => Material)
  material: Material;
}
